export enum PERK_REDEMPTION_TYPE {
  CouponList = "CouponList",
  ExternalLink = "ExternalLink",
  Shippable = "Shippable",
  Raffle = "Raffle",
  Simple = "Simple",
  Passport = "Passport",
}

export enum PERKS_CODE {
  AIDA = "ccl-aida",
  COSTA = "ccl-costa",
  CCL = "ccl-carnival-cruise-line",
  CUNARD = "ccl-cunard",
  HOLLAND = "ccl-holland-america-line",
  PO_UK = "ccl-po-cruises-uk",
  PO_AUS = "ccl-po-cruises-australia",
  PRINCESS = "ccl-princess",
  SEABOURN = "ccl-seabourn",
}

export enum PERK_TYPES {
  CouponList = "Coupon code",
  ExternalLink = "External link",
  Shippable = "Shippable",
  Simple = "Simple",
  // Raffle = "Raffle"
}

export enum RULES_LOGIC_KEYS {
  // NO_HOLDINGS = "NO_HOLDINGS",
  GREATER_THAN_OR_EQUAL_TO = "GREATER_THAN_OR_EQUAL_TO",
  BETWEEN = "BETWEEN",
}

export enum RULES_LOGIC {
  // NO_HOLDINGS = "No holdings",
  GREATER_THAN_OR_EQUAL_TO = "Greater than or equal to",
  BETWEEN = "Between",
}

export enum HOLDING_PERIOD {
  NOW = "NOW",
  WEEKS = "WEEKS",
  DAYS = "DAYS",
  MONTHS = "MONTHS",
}

export enum MAX_PERIOD {
  WEEKS = "12 weeks",
  DAYS = "120 days",
  MONTHS = "3 months",
}

export enum PERK_REDEMPTION_RULES {
  PERKS_NOT_ALREADY_REDEEMED = "PERKS_NOT_ALREADY_REDEEMED",
}

export enum ELIGIBILITY_TYPE {
  SHARES_CONFIGURATION = "SHARES_CONFIGURATION",
  EVERYONE_ELIGIBLE = "EVERYONE_ELIGIBLE",
}

export const ELIGIBILITY_TYPE_LABEL: Record<ELIGIBILITY_TYPE, string> = {
  [ELIGIBILITY_TYPE.SHARES_CONFIGURATION]: "Shares configuration",
  [ELIGIBILITY_TYPE.EVERYONE_ELIGIBLE]: "Everyone eligible",
}
